import { Cloud, FileSignature, Mail, type LucideIcon } from "lucide-react";

export interface IntegrationMeta {
  id: string;
  name: string;
  description: string;
  icon: LucideIcon;
  status: "available" | "coming-soon";
  path: string;
}

/** Organization-managed integrations (owner/manager). */
export const INTEGRATIONS: IntegrationMeta[] = [
  {
    id: "microsoft-365",
    name: "Microsoft 365",
    description:
      "Connect SharePoint, OneDrive, and Teams document libraries for contract import and KM ingestion across your organization.",
    icon: Cloud,
    status: "coming-soon",
    path: "/organization/integrations/microsoft-365",
  },
  {
    id: "email-inbox",
    name: "Email (Outlook/Exchange & IMAP)",
    description:
      "Connect your Outlook or IMAP inbox with read-only access so agents can reference email context during reviews and drafting.",
    icon: Mail,
    status: "available",
    path: "/settings/email",
  },
  {
    id: "docusign",
    name: "DocuSign",
    description:
      "Import signed agreements and envelope status into contract review and track execution workflows.",
    icon: FileSignature,
    status: "coming-soon",
    path: "/organization/integrations/docusign",
  },
];
